/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Spacer, theme, FlexContainer } from "@nordcloud/gnui";
import { Application } from "~/generated/graphql";
import { ApplicationDelete } from "./ApplicationDelete";
import { ApplicationEdit } from "./ApplicationEdit";

type Props = {
  application: Application;
};

export function Actions({ application }: Props) {
  const applicationName = application.displayName ?? application.name;

  return (
    <FlexContainer marginLeft={theme.spacing.spacing03}>
      <ApplicationEdit application={application} />
      <Spacer width={theme.spacing.spacing02} />
      <ApplicationDelete
        applicationId={application.id}
        name={applicationName}
      />
    </FlexContainer>
  );
}
